import getEnv from "helpers/get_env";
import getApp from "helpers/get_app";
export var SEGMENT_API_KEY = "qsiFG4InsIeUw7Quw3pN6QScMH1pjgJn";
export var TRACK_JS_TOKEN = "fd970d226c4b475d897759f950989046";
var ENV = getEnv();
var APP = getApp();
var CONFIG = {
    olo: {
        test: "olo-test",
        development: "olo-dev",
        staging: "olo-staging",
        production: "olo-prod",
    },
    pay: {
        test: "pay-test",
        development: "pay-dev",
        staging: "pay-staging",
        production: "pay-prod",
    },
    loyalty: {
        test: "loyalty-test",
        development: "loyalty-dev",
        staging: "loyalty-staging",
        production: "loyalty-prod",
    },
    giftCard: {
        production: "digital-gift-cards-prod",
    },
    unknown: {
        test: "unknown-test",
        development: "unknown-dev",
        staging: "unknown-staging",
        production: "unknown-prod",
    },
};
var TRACK_JS_APPLICATION_KEY = CONFIG[APP][ENV];
export { TRACK_JS_APPLICATION_KEY };
